import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Environment } from './environment.model';
import { PlatformLocation } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {

  finalEnvironment: Environment;
  local: boolean;

  constructor(
    private httpClient: HttpClient,
    private platformLocation: PlatformLocation
  ) {

  }

  async initEnvironment(): Promise<number> {
    this.local = false;
    this.finalEnvironment = environment;
    // let environmentServer: any;
    // const urlString = (this.platformLocation as any).location.origin;
    // environmentServer = await this.httpClient.get(`${urlString}/cronoss-environment.json`)
    // .pipe(catchError(this.handleError))
    // .toPromise();
    if (!this.local) {
      // this.finalEnvironment = new Environment();
      // this.finalEnvironment.availableDomains = environmentServer.availableDomains;
      // this.finalEnvironment.baseBackSSLUrl = environmentServer.availableDomains;
      // this.finalEnvironment.baseBackUrl = environmentServer.availableDomains;
      // this.finalEnvironment.envName = environment.envName;
      // this.finalEnvironment.security = environment.security;
    }
    return Promise.resolve(1);
  }

  // Handle API errors
  public handleError(): void {
    // console.log('Environment not found, begin with internal environment');
    this.local = true;
    return null;
  }

}
